import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Component } from 'react';

import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';

import withDefaultAppContexts from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { isMobile } from 'hb-react/frontoffice/utils/display';

import FooterButtons from './FooterButtons';

import styleModule from './index.module.scss';

class HeaderPage extends Component {
  renderVideos = () => (
    <video preload="auto" loop="loop" autoPlay>
      {this.props.videos.map((video) => (
        <source
          key={video.file_url}
          src={video.file_url}
          type={video.content_type}
        />
      ))}
    </video>
  );

  render() {
    const {
      custom_css_class: customCssClass,
      cover_picture: coverPicture,
      title,
      short_description: shortDescription,
      videos,
      enable_emphasize: enableEmphasize,
      enable_cover_bg: enableCoverBg,
      children,
      currentUser,
      html_block: htmlBlock,
      offline_payment_document: offlinePaymentDocument,
      onCoverClick,
      edit,
      onEditClick,
    } = this.props;
    const videoAvailable = !isMobile().any && videos.length > 0;
    const style = !videoAvailable
      ? { backgroundImage: `url('${coverPicture}')` }
      : {};

    return (
      <header>
        {enableCoverBg && (videoAvailable || coverPicture) && (
          <div
            className={`bg-cover relative ${styleModule.component}`}
            style={style}
            onClick={onCoverClick}
          >
            {edit && (
              <a
                className="deprecated--visuallyhidden--palm push absolute north east button button--small on-top"
                onClick={onEditClick}
              >
                {I18n.t('actions.edit')}
              </a>
            )}
            {enableEmphasize && (
              <div className="black-curtain north west one-whole absolute" />
            )}
            <div className="custom-section hidden" data-fetched-infos="true" />

            {videoAvailable && this.renderVideos()}

            <div
              className={classNames(
                'container--centered flexbox height-100-percent',
                {
                  custom_css_class: !!customCssClass,
                },
              )}
            >
              <div className="flexbox__item text--center color-white relative text-shadowed--verysoft">
                <div className={`push-half--bottom ${styleModule.title}`}>
                  <Dotdotdot clamp={3}>{title}</Dotdotdot>
                </div>
                <div className={styleModule.description}>
                  {shortDescription && shortDescription}
                  {children}
                </div>
              </div>
            </div>
            {currentUser && (
              <FooterButtons
                html_block={htmlBlock}
                link={offlinePaymentDocument}
              />
            )}
          </div>
        )}
        <div className="js-items-above" />
      </header>
    );
  }
}

HeaderPage.propTypes = {
  custom_css_class: PropTypes.string,
  cover_picture: PropTypes.string,
  videos: PropTypes.array,
  title: PropTypes.string,
  short_description: PropTypes.string,
  onCoverClick: PropTypes.func,
  onEditClick: PropTypes.func,
  enable_emphasize: PropTypes.bool,
  enable_cover_bg: PropTypes.bool,
  edit: PropTypes.bool,
};

HeaderPage.defaultProps = {
  videos: [],
  enable_emphasize: true,
  enable_cover_bg: true,
};

export default withDefaultAppContexts(HeaderPage);
